"use strict";
exports.__esModule = true;
exports.CURRENCY_CODES = void 0;
exports.CURRENCY_CODES = [
    'USD',
    'EUR',
    'TRY',
    'AUD',
    'DKK',
    'GBP',
    'CHF',
    'SEK',
    'CAD',
    'KWD',
    'NOK',
    'SAR',
    'JPY',
    'BGN',
    'RON',
    'RUB',
    'IRR',
    'CNY',
    'PKR',
];
//# sourceMappingURL=currency-codes.constant.js.map